import { motion } from "framer-motion";

import { cn, scoreColor, scoreToGrade } from "@/lib/formatters";

interface PendingPostCardProps {
  slug: string;
  title: string;
  category: string;
  score: number | null;
  createdAgo: string;
}

const categoryLabels: Record<string, string> = {
  automation: "automation",
  ai:         "ai",
  webdev:     "webdev",
  seo:        "seo",
  digital:    "digital",
};

export function PendingPostCard({
  slug,
  title,
  category,
  score,
  createdAgo,
}: PendingPostCardProps) {
  return (
    <motion.article
      layout
      variants={{
        hidden:  { opacity: 0, y: 8 },
        visible: { opacity: 1, y: 0 },
      }}
      whileHover={{ y: -2 }}
      transition={{ type: "spring", stiffness: 500, damping: 30 }}
      className="surface p-4 cursor-pointer hover:border-primary/30 group"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="path-chip">{categoryLabels[category] ?? category}</span>
            <span className="text-muted/40 font-mono text-xs">·</span>
            <span className="text-muted font-mono text-xs">{createdAgo}</span>
          </div>
          <h3 className="text-base text-text truncate group-hover:text-primary transition-colors">
            {title}
          </h3>
          <p className="text-xs text-muted font-mono mt-1 truncate">{slug}</p>
        </div>

        <div className="text-right shrink-0">
          <div className={cn("font-mono text-2xl leading-none", scoreColor(score))}>
            {scoreToGrade(score)}
          </div>
          <div className="text-xs text-muted font-mono mt-1">
            {score != null ? `${Math.round(score)}/100` : "no audit"}
          </div>
        </div>
      </div>
    </motion.article>
  );
}
